import React from 'react';
import { AlertTriangle, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useZoho, useAuth } from '../../context';
import { apiZohoAuthUrl } from '../../api';

export default function ZohoStatusBanner() {
  const { connected, checked } = useZoho();
  const { jwtToken, user } = useAuth();
  const navigate = useNavigate();
  const [connecting, setConnecting] = React.useState(false);

  if (user?.role !== 'admin' || !checked || connected) return null;

  const handleConnect = async () => {
    setConnecting(true);
    try {
      const { url } = await apiZohoAuthUrl(jwtToken);
      window.location.href = url;
    } catch (e) {
      alert('Failed to start Zoho authorization: ' + e.message);
      setConnecting(false);
    }
  };

  return (
    <div className="alert-banner alert-banner-danger" role="alert">
      <AlertTriangle size={18} style={{ flexShrink: 0, marginTop: 1 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="alert-banner-title">Zoho Mail is not connected.</div>
        <div>
          No outgoing emails will be sent — client welcome emails, milestone
          notifications, upload requests, and bulk campaigns are all paused
          until you reconnect.
        </div>
        <div className="alert-banner-actions">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleConnect}
            disabled={connecting}
          >
            <Mail size={14} /> {connecting ? 'Redirecting…' : 'Connect Zoho Now'}
          </button>
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            onClick={() => navigate('/mailer')}
          >
            Open Mailer
          </button>
        </div>
      </div>
    </div>
  );
}
